import Map from 'eemovel-map-library/src/data/google-maps/map';
import { loading } from '../../../../layout/redux/layoutActions';
import Icon from '../../../../assets/img/CIRCLE-red-border.svg';
import { updateClusters, updateMarkers } from '../../redux/dashboardActions';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import ClusterIcon from '../../../../assets/img/Ellipse_39.svg';
import {
  generateInfoWindow,
  generateMultipleAdvertsFoundInfoWindow,
} from '../redux/offersSecondary.controller';

export const generateMarkersOnMap = (geometry, type, payload) => {
  return (dispatch) => {
    dispatch(loading());
    const google = window.google;

    const mappedCoordinates = geometry.map((el) => ({
      coordinates: new google.maps.LatLng(
        el?.location_point[0],
        el?.location_point[1]
      ),
      rgi: el?.rgi,
      processed_address_number: el?.processed_address_number,
      processed_address_street: el?.processed_address_street,
    }));

    const markers = mappedCoordinates.map((el, index) => {
      const marker = new google.maps.Marker({
        position: el.coordinates,
        map: Map.map,
        icon: Icon,
        processed_address_street: el?.processed_address_street,
        processed_address_number: el?.processed_address_number,
        optimized: true,
      });
      if (type === 'secondary') {
        marker.addListener('click', function () {
          dispatch(
            generateInfoWindow(
              payload,
              el?.processed_address_number,
              el?.processed_address_street,
              marker
            )
          );
        });
      }
      return marker;
    });
    const clusterOptions = {
      optimized: true,
      zoomOnClick: false,
      styles: [
        {
          url: ClusterIcon,
          height: 24,
          width: 24,
          textColor: '#FFF',
          fontWeight: 400,
          textSize: 14,
          anchorText: [5, 0],
        },
      ],
    };

    const map = Map.map;
    const markerCluster = new MarkerClusterer(map, markers, clusterOptions);
    markerCluster.addListener('clusterclick', function (cluster) {
      Map.map.fitBounds(cluster.getBounds());
      const markers = cluster.getMarkers();
      if (markers) {
        const payloadArray = markers.map((marker) => {
          const { processed_address_number, processed_address_street } = marker;
          return {
            ...payload,
            processed_address_number,
            processed_address_street,
            id: Math.ceil(Math.random() * 100001),
          };
        });
        dispatch(generateMultipleAdvertsFoundInfoWindow(payloadArray, markers));
      }
    });
    dispatch(updateMarkers(markers));
    dispatch(updateClusters(markerCluster));
  };
};
